export default ({ e = {}, context }) => ({
    context: {
        label: e.currentTarget && e.currentTarget.textContent,
        location: window.location.href,
        referrer: document.referrer || 'Direct',
        ...context,
    },
});
